(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["elikmed-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elikmed-description-label')) {
    customElements.define('elikmed-description-label', class extends HTMLElement {
      connectedCallback() {
        this.details = this.closest('details');
        this.description = this.closest('.elikmed-product-description');
        this.summary = this.details.querySelector('summary');
        this.summary.addEventListener('click', this.toggleDescription);
        this.details.addEventListener('toggle', this.updateLabel);
        window.addEventListener('resize', this.handleResize);
        this.updateLabel();
      }

      disconnectedCallback() {
        this.summary.removeEventListener('click', this.toggleDescription);
        this.details.removeEventListener('toggle', this.updateLabel);
        window.removeEventListener('resize', this.handleResize);
        this.cancelAnimation();
      }

      cancelAnimation = () => {
        this.animation?.cancel();
        this.animation = null;
      };

      handleResize = () => {
        if (this.description.getBoundingClientRect().width !== this.animationWidth) this.cancelAnimation();
      };

      toggleDescription = (event) => {
        if (event.defaultPrevented) return;
        event.preventDefault();

        const startHeight = this.description.getBoundingClientRect().height;
        this.cancelAnimation();
        this.details.open = !this.details.open;
        this.updateLabel();
        const endHeight = this.description.getBoundingClientRect().height;
        this.animationWidth = this.description.getBoundingClientRect().width;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.animation = this.description.animate(
          [
            { height: `${startHeight}px`, overflow: 'clip' },
            { height: `${endHeight}px`, overflow: 'clip' },
          ],
          { duration: 450, easing: 'ease' }
        );
        this.animation.onfinish = this.cancelAnimation;
      };

      updateLabel = () => {
        this.textContent = this.details.open ? 'Read Less' : 'Read More';
      };
    });
  }
  } catch(e) { console.error(e); }
})();

})();
